import { cn } from "../../lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import { motion } from "framer-motion";

export const ErrorIconClasses = cva("", {
    variants: {
        color: {
            default: "text-red-400 dark:text-red-300",
            dark: "text-red-300 dark:text-red-400"
        },
        size: {
            default: "h-4 w-4"
        }
    },
    defaultVariants: {
        color: "default",
        size: "default"
    }
});

interface ErrorIconProps extends VariantProps<typeof ErrorIconClasses> {
    className?: string;
    strokeWidth?: number;
}

export default function ErrorIcon({ className, size, color, strokeWidth = 3 }: ErrorIconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={strokeWidth} stroke="currentColor" className={cn(ErrorIconClasses({ color, size, className }))}>
            <motion.path strokeLinecap="round" strokeLinejoin="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.7 }} d="M6 18L18 6M6 6l12 12" />
        </svg>
    );
}
